


export const login = async (user) => {

    let res = await request.post('/user/login',user);
    return res.data;
}



export const get_user = async(id)=>{
    let token = cookie.get('token');
    request.auth(token);
    let res = await request.get(`/user/${id}`);

    return res.data;
}